module.exports = __webpack_public_path__ + "static/media/pinterest.e1ae7325.svg";